import React, {useState} from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {Spinner} from "react-bootstrap";

const SettingTable = ({ t, list, getSelected, unSelected }) => {

    const [selected, setSelected] = useState([]);

    const columns = [
        {
            Header: 'id',
            accessor: 'id'
        },
        {
            Header: 'key',
            accessor: 'key'
        },
        {
            Header: 'value',
            accessor: 'value'
        },
        {
            Header: 'value-type',
            accessor: 'valueType'
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('device-type-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                    getTrProps={(state, rowInfo, columns) => {
                        return {
                            onClick: (e) => {
                                let a = selected.indexOf(rowInfo.index);
                                if (a === -1) {
                                    // this.setState({selected: array.concat(this.state.selected, [rowInfo.index])});
                                    setSelected( [ rowInfo.index]);
                                    getSelected(rowInfo.original);
                                    // Pass props to the React component
                                } else {
                                    setSelected([]);
                                    getSelected(null);
                                }
                            },
                            // #393740 - Lighter, selected row
                            // #302f36 - Darker, not selected row
                            style: {background: (selected.indexOf(rowInfo.index) === -1) ? '#FFFFFF': '#f8f9fa'},
                        }
                    }}
                    // onClickRow={handleClickRow}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )

    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )
};
export default withNamespaces()(SettingTable);
